import DateUtils from '@/core/utils/date-utils'

export const LoginUtils = {

  isLoggedUser: () => {
    const token = localStorage.getItem('token')

    if (token) {
      const loggedUser = localStorage.getItem('loggedUser')
      if (loggedUser && loggedUser.lastAccessPlataformDate) {
        const isTimeSessionValidate = DateUtils.create(loggedUser.lastAccessPlataformDate).add(30, 'minutes').isSameOrAfter(new Date())

        if (isTimeSessionValidate) {
          const loggedUser = localStorage.getItem('loggedUser')
          loggedUser.lastAccessPlataformDate = new Date()

          localStorage.setItem('loggedUser', JSON.stringify(loggedUser))
        }

        return isTimeSessionValidate
      }
      return false
    }
    return token
  },

  getUser: () => JSON.parse(localStorage.getItem('loggedUser')),

  setUser: user => {
    user.lastAccessPlataformDate = new Date()
    localStorage.setItem('loggedUser', JSON.stringify(user))
  },

  getToken: () => localStorage.getItem('token'),

  setToken: token => {
    localStorage.setItem('token', token)
  },

  logout: () => {
    localStorage.removeItem('token')
    localStorage.removeItem('loggedUser')
  },

  isPwa: () => {
    return ["standalone", "minimal-ui"].some(
      (displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches
    )
  }

}

export default LoginUtils
